import * as React from 'react';
export var useProgressBar = function useProgressBar(_ref) {
  var value = _ref.value,
    maxValue = _ref.maxValue;
  var fillWidthPercent = React.useMemo(function () {
    var result = value / (maxValue || 1) * 100;
    if (result > 100) {
      return 100;
    }
    if (result < 0) {
      return 0;
    }
    return result;
  }, [value, maxValue]);
  return {
    fillWidthPercent: fillWidthPercent
  };
};